import type { CreatedWorksheet } from "@bindery/shared/contracts/worksheet";
import type { GeneratedWorksheet, OptionsProvider } from "@bindery/worksheets";

export type Random = () => number;

export async function loadOptionsProvider(): Promise<OptionsProvider> {
  const { lookupWordOptions } =
    await import("@bindery/corpus-pipeline/pipeline/cdn/word-options-browser");
  return lookupWordOptions;
}

async function generateFirstSheet(random: Random): Promise<GeneratedWorksheet> {
  const [{ FIRST_PLACEMENT, generateWorksheet }, getOptions] =
    await Promise.all([import("@bindery/worksheets"), loadOptionsProvider()]);
  return generateWorksheet({
    placement: FIRST_PLACEMENT,
    lexicon: null,
    getOptions,
    random,
  });
}

export interface CreateWorksheetDeps {
  generate?: (random: Random) => Promise<GeneratedWorksheet>;
  random?: Random;
}

export function createWorksheetFor(
  expectedReaderId: string,
  store: (args: {
    expectedReaderId: string;
    placement: number;
    content: GeneratedWorksheet["content"];
  }) => Promise<CreatedWorksheet>,
  {
    generate = generateFirstSheet,
    random = Math.random,
  }: CreateWorksheetDeps = {},
): Promise<CreatedWorksheet> {
  return generate(random).then(({ placement, content }) =>
    store({ expectedReaderId, placement, content }),
  );
}
